import { CURRENT_YEAR, VERIFIED_YEAR } from '../../../Config/League/league.config'
import { API_ENDPOINTS } from '../../utils/endpoints'
import { makeAPIRequest } from '../../utils/request'
import type { AcademyEvent, AcademyVerified } from './academyEvents.types'

export const fetchActiveAcademyEvents = async (): Promise<AcademyEvent[] | null> => {
  try {
    const evRes = await makeAPIRequest(API_ENDPOINTS.ACADEMY_EVENTS, {
      method: 'GET',
      apiVersion: '1',
      queryParams: {
        year: CURRENT_YEAR,
      },
    })
    if (!evRes?.data) return []
    return evRes?.data
  } catch (error) {
    return []
  }
}

export const fetchAcademyVerified = async (): Promise<AcademyVerified[] | null> => {
  try {
    const verifiedRes = await makeAPIRequest(API_ENDPOINTS.ACADEMY_VERIFIED_CLUBS, {
      method: 'GET',
      apiVersion: '1',
      queryParams: {
        year: VERIFIED_YEAR,
      },
    })
    const verifiedClubs = verifiedRes?.data
    if (!verifiedClubs) return []
    return verifiedClubs
  } catch (error) {
    return []
  }
}
